export const magdalenaDabrowska = {
    'meta': {
        'title': 'Psycholog, Psychoterapeuta Magdalena Dąbrowska • COLLIGO',
        'description': 'Jestem psychologiem, psychoterapeutą, ukończyłam studia magisterskie z psychologii, o specjalności psychologia kliniczna dzieci i młodzieży.'
    },
    'url': {
        'address': '/torun/zespol/psycholog-psychoterapeuta-magdalena-dabrowska/'
    },
    'opengraph': {
        'image': {
            'url': '/images/team/open-graph/magdalena-dabrowska.webp',
            'width': 150,
            'height': 150,
            'alt': 'Psycholog, Psychoterapeuta Magdalena Dąbrowska'
        }
    }
}